import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {Router, Event, NavigationStart, NavigationEnd, NavigationError} from '@angular/router';

declare var jquery:any;
declare var $ :any;

import * as M from "materialize-css/dist/js/materialize";
import 'materialize-css/dist/js/materialize.js'

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {

    user:Object;
    public isAdmin:boolean;
    public isSuperAdmin:boolean;
    public isTrafalgar:boolean;
    public showEvents:boolean;
  constructor(public authService:AuthenticationService, private router:Router) {
    router.events.subscribe((val) => {
        // see also



    });

    router.events.subscribe( (event: Event) => {
        if (event instanceof NavigationStart) {
            // Show loading indicator
        }

        if (event instanceof NavigationEnd) {
      ////console.log("router works")

            // Hide loading indicator
            $(document).ready(function(){ $('ul.tabs').tabs(); });
            //////console.log("router change");
            this.authService.getProfile().subscribe((user) => {
              this.user=  user;
              this.isAdmin = this.user[0].user.isAdmin;
              if(!this.isAdmin){
                this.router.navigate(['/admin/events']);
              }
              this.isSuperAdmin = this.user[0].user.isSuperAdmin;
              
              //////console.log(this.user[0].user.account_ID)
              if(!this.isSuperAdmin)
              {
                if(this.user[0].user.account_ID == '5b8c1a2da9a50c0759567842'){
                 // ////console.log("This is trafalgar");
                  this.isTrafalgar = true;
                  this.showEvents = false;
                }else{
                  this.isTrafalgar = false;
                  this.showEvents = true;
                }
              } else if(!this.isAdmin){
                this.router.navigate(['/admin/events']);
              
              } else{
                this.isTrafalgar = false;
                this.showEvents = false;
              }
             
              //////console.log(this.isAdmin);
            },
          err=>{
            //////console.log(err);
            return false;
          });
        }

        if (event instanceof NavigationError) {
            // Hide loading indicator
            // Present error to user
            //////console.log(event.error);
        }
    });
  }

  ngOnInit() {

    this.isTrafalgar = false;
    this.showEvents = true;
        $(document).ready(function(){ $('ul.tabs').tabs(); });



  }

    onLogoutClick(){
      this.authService.logout();
      this.router.navigate(['admin/login']);
      return false;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/nav/nav.component.ts